export default () => ({
  errors: {},
  password: {
    current_password: null,
    password: null,
    confirmed: null
  }
})



// WEBPACK FOOTER //
// ./src/app/settings/profile/components/resources/data.js